<template>
  <div class="authorityManagement">
    <commonHeader :tabs-list="tabsList" :tabs-default="activeName" @handleTabsClick="handleTabsClick" :breadcrumb-show="false">
      <template #buttons>
        <el-button type="primary" @click="ComUpleader">保存</el-button>
      </template>
    </commonHeader>
    <div class="authorityManagementContent">
      <div class="header">
        <div class="title">
          <img src="@/assets/images/informationIcon.png">
          <span>角色名称</span>
        </div>
      </div>
      <div class="wrap">
        <div class="tree">
          <ul>
            <li v-for="(item,index) in roleList" :key="index" :class="activeIndex === index ? 'active' : ''">
              <p @click="getJurisdictionData(item, index)">{{ item.roleName }}</p>
            </li>
          </ul>
        </div>
        <div class="content">
          <functionPermissions ref="FunctionSion" :functionlead="leadFunction" :trastlist="functionLeadList" v-show="activeName === 'functionPermissions'" />
          <fieldPermissions ref="FieldSion" :fieldlead="leadField" :trastlist="fieldLeadList" v-show="activeName === 'fieldPermissions'" />
          <dataPermissions ref="DataSion" :datalead="leadData" :trastlist="dataLeadList" v-show="activeName === 'dataPermissions'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader';
import functionPermissions from './component/authorityManagement/functionPermissions';
import fieldPermissions from './component/authorityManagement/fieldPermissions';
import dataPermissions from './component/authorityManagement/dataPermissions';
import { roleManagementApi, authorityManagementApi } from './service';
export default {
  data () {
    return {
      activeIndex: 0,
      activeName: 'functionPermissions',
      tabsList: [
        {
          label: '功能权限',
          name: 'functionPermissions'
        },
        {
          label: '字段权限',
          name: 'fieldPermissions'
        },
        {
          label: '数据权限',
          name: 'dataPermissions'
        }
      ],
      roleList: [],
      // 所有选择列表
      leadFunction: [],
      leadData: [],
      leadField: [],
      roleId: '',
      // 对比列表选中与不选中
      functionLeadList: [],
      dataLeadList: [],
      fieldLeadList: []
    };
  },
  components: {
    commonHeader,
    functionPermissions,
    fieldPermissions,
    dataPermissions
  },
  methods: {
    getJurisdictionData (item, index) {
      this.activeIndex = index;
      this.roleId = item.roleId;
      this.$store.commit('setSubPageLoading', true);
      authorityManagementApi.getManageList(item.roleId).then(res => {
        res.data.forEach(val => {
          switch (val.permissionType) {
            case 'lead_filed':
              this.fieldLeadList = val.optionVOList;
              break;
            case 'lead_data':
              this.dataLeadList = val.optionVOList;
              break;
            case 'lead_function':
              this.functionLeadList = val.optionVOList;
              break;
          }
        });
        this.$store.commit('setSubPageLoading', false);
      });
    },
    handleTabsClick (val) {
      this.activeName = val.name;
    },
    getRoleList () {
      roleManagementApi.getRoleList().then(res => {
        if (res.status === '200') {
          this.roleList = res.data;
          this.getJurisdictionData(this.roleList[0], this.activeIndex);
        }
      });
    },
    getOptionList () {
      authorityManagementApi.getOptionList().then(res => {
        if (res.status === '200') {
          res.data.forEach(val => {
            switch (val.permissionType) {
              case 'lead_filed':
                this.leadField = val.optionVOList;
                break;
              case 'lead_data':
                this.leadData = val.optionVOList;
                break;
              case 'lead_function':
                this.leadFunction = val.optionVOList;
                break;
            }
          });
        }
      });
    },
    ComUpleader () {
      // console.log(this.$refs.DataSion.formData, this.$refs.FieldSion.formData, this.$refs.FunctionSion.formData, this.$refs);
      let dataArr = [];
      for (const key in this.$refs) {
        let FormData = this.$refs[key].formData;
        for (const item in FormData) {
          if (typeof FormData[item] === 'object') {
            FormData[item].forEach(val => {
              dataArr.push(val);
            });
          } else if (typeof FormData[item] === 'string') {
            dataArr.push(FormData[item]);
          }
        }
      }
      let params = {
        roleId: this.roleId,
        permissionIds: dataArr
      };
      this.$store.commit('setSubPageLoading', true);
      authorityManagementApi.PostUpdata(params).then(res => {
        if (res.status === '200') {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
        }
        this.$store.commit('setSubPageLoading', false);
      });
    }
  },
  mounted () {
    this.getOptionList();
    this.getRoleList();
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/common";
.authorityManagementContent{
  >.header{
    @extend .clear;
    >.title{
      width: 16%;
      padding: 10px 0;
      line-height: 30px;
      float: left;
      margin-right: 16px;
      >img{
        width: 30px;
        vertical-align: middle;
        margin-right: 12px;
      }
      >span{
        color: #424C57;
        font-size: 16px;
        vertical-align: middle;
      }
    }
  }
  >.wrap{
    display: flex;
    >.tree{
      width: 16%;
      min-height: 100%;
      margin-right: 16px;
      background: #FCFDFE;
      border: 1px solid #DEE1E7;
      >.addOperationButton{
        height: 60px;
        line-height: 60px;
        text-align: center;
        cursor: pointer;
        border-bottom: 1px solid #EDEDED;
        >i{
          margin-right: 10px;
          color: #7E8A9D;
          vertical-align: middle;
        }
        >span{
          color: #424C57;
          vertical-align: middle;
          font-size: 16px;
        }
      }
      >ul{
        >li{
          line-height: 54px;
          position: relative;
          >p{
            padding-left: 20px;
            padding-right: 60px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            cursor: pointer;
            color: #424C57;
          }
          >span{
            display: none;
            position: absolute;
            right: 20px;
            top: 0;
            color: #17A58A;
            cursor: pointer;
          }
          &.active{
            background: #ECF6F5;
            >p{
              color: #17A58A;
            }
          }
          &:hover span{
            display: inline;
          }
        }
      }
    }
    >.content{
      flex: 1;
      min-height: 100%;
      border: 1px solid #DEE1E7;
      background: #FCFDFE;
      padding: 16px;
    }
  }
}
</style>
